import { render, staticRenderFns } from "./TabPrecoManageModal.vue?vue&type=template&id=9054e9a4&scoped=true"
import script from "./TabPrecoManageModal.vue?vue&type=script&lang=js"
export * from "./TabPrecoManageModal.vue?vue&type=script&lang=js"
import style0 from "./TabPrecoManageModal.vue?vue&type=style&index=0&id=9054e9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9054e9a4",
  null
  
)

export default component.exports